import { observer } from 'mobx-react';
import { T } from '../../Translations';
import ClickableTooltip from '../ClickableTooltip';
import InfoIcon from '../Cutesies/InfoIcon';
import TooltipIcon from '../Cutesies/TooltipIcon';
import AddCollectionViaOverlayLink from './AddCollectionViaOverlayLink';

function Headers() {
  return (
    <div className="bg-white border-b-1 pb-4 border-b-gray-200">
      <div className="max-w-clientPortalMaxWidth mx-auto w-full overflow-x-hidden">
        <div className="flex flex-col justify-between md:flex-row lg:px-12 px-2.5">
          <div>
            <div>
              <div className="flex items-center">
                <h2 className="text-2xl font-semibold text-gray-900 items-center">
                  <T kind="Learning Collections" />
                </h2>
                <ClickableTooltip tooltipId={'learning-collections'} tooltipIcon={<TooltipIcon />}>
                  <T
                    kind={'Use Learning Collections to curate...'}
                    link={(content) => (
                      <a
                        href="https://execonline.atlassian.net/l/cp/pJp12UKU"
                        rel="nofollow noopener noreferrer"
                        target="_blank"
                        className="text-teal-400 underline"
                      >
                        {content}
                      </a>
                    )}
                  />
                </ClickableTooltip>
              </div>
            </div>
            <div className="pt-5 pb-2">
              <T kind="Collaborate with your team to ..." />
            </div>
          </div>
          <div className="mt-2 flex flex-col items-end md:mt-0 md:flex-row md:items-center">
            <a
              href="https://execonline.atlassian.net/wiki/spaces/ACKB/pages/3675095061/What+should+I+consider+when+creating+a+Learning+Collection"
              target="_blank"
              rel="noopener noreferrer"
              className="flex mb-1 md:mr-3 md:mb-0"
            >
              <InfoIcon />
              <p className="text-xs text-teal-600 font-bold">
                <T kind="Need help getting started?" />
              </p>
            </a>
            <AddCollectionViaOverlayLink />
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Headers);
